import * as React from "react";
import { QuestionsIF } from "../QuestionsIF";
import { LocationQuestionsIndex } from "./locationQuestions/locationQuestionsIndex";
import { RangeQuestionsIndex } from "./rangeQuestionsIndex";
import { LocationRefinementQuestion } from "./locationRefinementQuestion";
import { usePatientFeatureFlags } from "../../../hooks/usePatientFeatureFlags";
import { RefinementQuestion } from "../refinementQuestion";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface RangeQuestionProps extends QuestionsIF {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RangeQuestion = ({ ...props }: RangeQuestionProps) => {
  const rangeQuestionsEnabled = usePatientFeatureFlags("rangeQuestions");

  const questionsRangeId =
    props.question.suggestions?.[0].refinementLocationRange?.id;

  const suggestionFeatureId =
    props.question.suggestions?.[0].suggestion?.feature?.id;

  // const isNumeric =
  //   props.question?.questionChoiceType === QuestionChoiceType.ChooseNumeric;

  const isRangeInLocationMaps = LocationQuestionsIndex.some(
    (questionIndex) => questionIndex.rangeId === questionsRangeId,
  );

  if (isRangeInLocationMaps) return <LocationRefinementQuestion {...props} />;

  const inGeneralRanges = RangeQuestionsIndex.find(
    (questionIndex) =>
      questionIndex.rangeId === questionsRangeId &&
      (!questionIndex.featureId ||
        questionIndex.featureId === suggestionFeatureId),
  );

  if (inGeneralRanges && rangeQuestionsEnabled) {
    return <inGeneralRanges.component {...props} />;
  }

  // Automatically fall into refinement question
  return <RefinementQuestion {...props} />;
};
